import { render, staticRenderFns } from "./MshipsForm.vue?vue&type=template&id=79cf97f6"
import script from "./MshipsForm.vue?vue&type=script&lang=js"
export * from "./MshipsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports